import React, { useEffect, useRef, useState } from 'react';
import * as S from './AccessOverlay.style';
import { MarketMicrostructureBackdrop } from './MarketMicrostructureBackdrop.component';

interface Props {
  active: boolean;
}

const DISSOLVE_MS = 420;

export const AccessBackdrop: React.FC<Props> = ({ active }) => {
  const [isExiting, setIsExiting] = useState(false);
  const wasVisible = useRef(active);

  useEffect(() => {
    if (active) {
      setIsExiting(false);
      wasVisible.current = true;
      return;
    }

    if (!wasVisible.current) {
      return;
    }

    setIsExiting(true);
    const timeoutId = window.setTimeout(() => {
      setIsExiting(false);
      wasVisible.current = false;
    }, DISSOLVE_MS);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [active]);

  const shouldRender = active || isExiting || wasVisible.current;

  if (!shouldRender) {
    return null;
  }

  return (
    <S.BackgroundOnlyOverlay aria-hidden="true" $visible={active} $exiting={isExiting}>
      <S.BackgroundLayer>
        <MarketMicrostructureBackdrop />
      </S.BackgroundLayer>
      <S.BackgroundVeil />
    </S.BackgroundOnlyOverlay>
  );
};
